import { Modal, ModalHeader, Typography, Separator, ModalBody, ModalFooter, Button } from '@pw-tech/omni-ui';
import React from 'react';
type Props = {
  isOpen: boolean;
  children: any;
  title: string;
  onClose: () => void;
  onSubmit?: () => void;
  cancelText?: string;
  submitText?: string;
  showHeader?: boolean;
  showFooter?: boolean;
  showCancelButton?: boolean;
  showSubmitButton?: boolean;
  closeOnOutsideClick?: boolean;
  showSeparator?: boolean;
  showCloseIcon?: boolean;
  size?: 'extra-small' | 'small' | 'medium' | 'large';
  className?: string;
};
const DialogModal = ({
  isOpen = false,
  children,
  title = '',
  onClose,
  onSubmit,
  cancelText = 'Cancel',
  submitText = 'Submit',
  showHeader = true,
  showFooter = true,
  showCancelButton = true,
  showSubmitButton = true,
  closeOnOutsideClick = true,
  showSeparator = false,
  showCloseIcon = true,
  size = 'large',
  className = ''
}: Props) => {
  return <Modal closeOnOutsideClick={closeOnOutsideClick} onClose={onClose} showCloseIcon={showCloseIcon} size={size} isOpen={isOpen} className={className} data-sentry-element="Modal" data-sentry-component="DialogModal" data-sentry-source-file="DialogModal.tsx">
      {showHeader ? <ModalHeader>
          <Typography variant="heading3" weight="semi-bold" className="pt-2">
            {title}
          </Typography>
        </ModalHeader> : <></>}
      {showSeparator ? <Separator /> : <></>}
      <ModalBody data-sentry-element="ModalBody" data-sentry-source-file="DialogModal.tsx">{children}</ModalBody>
      {showFooter ? <ModalFooter>
          <div className="flex flex-row items-center justify-end gap-2">
            {showCancelButton && <Button className="Modal_buttonClassName__SXfTH" size="small" variant="secondary" onClick={onClose}>
                {cancelText}
              </Button>}
            {showSubmitButton && <Button className="Modal_buttonClassName__SXfTH" size="small" variant="primary" onClick={onSubmit}>
                {submitText}
              </Button>}
          </div>
        </ModalFooter> : <></>}
    </Modal>;
};
export default DialogModal;